<template>
  <div class="animated fadeIn">
    <b-card
      style="max-width: 1080px"
      bg-variant="light"
    >
      <div class="chart-wrapper">
        <ApexBar
          type="line"
          :options="getOptions"
          :series="getSeries"
          height="310"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import Line from "vue-apexcharts";

export default {
  name: "BarComboChart",
  components: {
    ApexBar: Line,
  },
  props: ['cumulativeRegisteredDevices', 'registeredDevices', 'categories'],
  computed: {
    getSeries () {
      return [
        {
          name: "Registered",
          type: "column",
          data: this.registeredDevices,
        },
        {
          name: "Cumulative Registered",
          type: "line",
          data: this.cumulativeRegisteredDevices,
        },
      ]
    },
    getOptions () {
      return {
        chart: {
          fontFamily: 'Nunito Sans, arial, serif',
        },
        colors: ["#155F82", "#E97132"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 4],
        },
        title: {
          text: "New Registered Devices",
          align: "left",
          offsetX: 110,
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: [
          {
            seriesName: "Registered",
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#0F3E52",
            },
            labels: {
              style: {
                colors: "#0F3E52",
              },
            },
            tooltip: {
              enabled: true,
            },
          },
          {
            seriesName: "Cumulative Registered",
            opposite: false,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#AB5626",
            },
            labels: {
              style: {
                colors: "#AB5626",
              },
            }
          },
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60,
          },
        },
        legend: {
          horizontalAlign: "left",
          offsetX: 40,
        },
      }
    }
  },
};
</script>
